import { FC, useId } from 'react';

type ArrowUpIconProps = {
    width?: number;
    height?: number;
    fill?: string;
    className?: string;
};

export const ArrowUpIcon: FC<ArrowUpIconProps> = ({ height = 25, width = 25, fill = 'currentColor', className }) => {
    const clipPathId = useId();

    return (
        <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} fill="none" className={className} xmlns="http://www.w3.org/2000/svg">
            <g clipPath={`url(${clipPathId})`}>
                <path
                    d="M11.5293 0.399591L2.50075 9.42797C2.24302 9.6857 2.10156 10.0292 2.10156 10.3954C2.10156 10.7621 2.24323 11.1054 2.50075 11.3631L3.32066 12.1828C3.57797 12.4403 3.92167 12.5822 4.28813 12.5822C4.65439 12.5822 5.00967 12.4403 5.26698 12.1828L10.5456 6.9158L10.5456 23.6494C10.5456 24.4039 11.1362 25 11.8909 25L13.05 25C13.8047 25 14.4549 24.4039 14.4549 23.6494L14.4549 6.85604L19.763 12.1826C20.0207 12.4401 20.3551 12.582 20.7215 12.582C21.0876 12.582 21.4268 12.4401 21.6843 12.1826L22.5016 11.3629C22.7593 11.1052 22.8998 10.7619 22.8998 10.3952C22.8998 10.029 22.7575 9.68549 22.4998 9.42777L13.4714 0.399389C13.2129 0.141057 12.8677 -0.00101518 12.5009 1.45278e-06C12.1328 -0.000811062 11.7875 0.141058 11.5293 0.399591Z"
                    fill={fill}
                />
            </g>
            <defs>
                <clipPath id={clipPathId}>
                    <rect width={width} height={height} fill="white" transform={`translate(0 ${height}) rotate(-90)`} />
                </clipPath>
            </defs>
        </svg>
    );
};
